import * as XLSX from "xlsx";

const REQUIRED_COLUMNS = [
    "Nombre_Broker",
    "Correo",
    "Ingreso_Mes",
    "Meta_Trimestral",
    "Meta_Anual",
    "N_Cierres_Mensual",
    "N_Cierres_Anual",
    "Visualizaciones_Propiedades",
    "N_Stocks",
    "Ingreso_Anual",
    "Ingreso_Trimestral"
];

export const parseExcelFile = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                if (jsonData.length === 0) {
                    return reject(new Error("El archivo Excel está vacío."));
                }

                const headers = Object.keys(jsonData[0]);
                const missingColumns = REQUIRED_COLUMNS.filter(
                    (col) => !headers.includes(col)
                );

                if (missingColumns.length > 0) {
                    return reject(
                        new Error(
                            `Faltan las siguientes columnas obligatorias: ${missingColumns.join(
                                ", "
                            )}`
                        )
                    );
                }

                const INTEGER_COLS = ["N_Cierres_Mensual", "N_Cierres_Anual", "Visualizaciones_Propiedades", "N_Stocks"];
                const DECIMAL_COLS = ["Ingreso_Mes", "Meta_Trimestral", "Meta_Anual", "Ingreso_Anual", "Ingreso_Trimestral"];

                const parseNumericValue = (val, isInteger) => {
                    if (typeof val === 'number') {
                        return isInteger ? Math.trunc(val) : val;
                    }
                    if (typeof val === 'string') {
                        let clean = val.trim().replace(/[$% ]/g, '');
                        // Replace comma with dot if there is no dot and there is a comma
                        // Or if comma is after dot
                        const lastCommaPos = clean.lastIndexOf(',');
                        const lastDotPos = clean.lastIndexOf('.');

                        if (lastCommaPos > lastDotPos && lastDotPos !== -1) {
                            clean = clean.replace(/\./g, '').replace(',', '.');
                        } else if (lastDotPos > lastCommaPos && lastCommaPos !== -1) {
                            clean = clean.replace(/,/g, '');
                        } else if (lastCommaPos !== -1 && lastDotPos === -1) {
                            clean = clean.replace(',', '.');
                        }

                        // For integer, strip any decimals that might have been typed/parsed
                        if (isInteger) {
                            const decimalPos = clean.indexOf('.');
                            if (decimalPos !== -1) {
                                clean = clean.substring(0, decimalPos);
                            }
                        }

                        // Further remove any non-digit/dot/minus characters
                        if (isInteger) {
                            clean = clean.replace(/[^0-9-]/g, '');
                        } else {
                            clean = clean.replace(/[^0-9.-]/g, '');
                        }

                        const parsed = isInteger ? parseInt(clean, 10) : parseFloat(clean);
                        return isNaN(parsed) ? 0 : parsed;
                    }
                    return 0;
                };

                const extNumCols = REQUIRED_COLUMNS.filter(c => c !== "Nombre_Broker" && c !== "Correo" && c !== "Mes" && c !== "VersionMes");

                const enrichedData = jsonData.map((row, index) => {
                    const parsedRow = { ...row };
                    extNumCols.forEach((col) => {
                        const isInteger = INTEGER_COLS.includes(col);
                        parsedRow[col] = parseNumericValue(parsedRow[col], isInteger);
                    });

                    return {
                        id: `row-${index}-${Date.now()}`,
                        ...parsedRow,
                    };
                });

                resolve(enrichedData);
            } catch (error) {
                reject(new Error("Error al procesar el archivo Excel. Asegúrese de que el formato sea válido."));
            }
        };

        reader.onerror = () => {
            reject(new Error("Error al leer el archivo."));
        };

        reader.readAsBinaryString(file);
    });
};
